// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3orIp","clinicsSelect":"styles_clinicsSelect__1fa4f"};